export const partners = [
  {
    title: 'ASCOPA',
    logo: '/partners/ascopa.png',
    link: 'https://ascopa.cz/',
  },
  {
    title: 'APRA',
    logo: '/partners/apra.png',
    link: 'https://www.apra.cz/',
  },
  {
    title: 'CAMIC',
    logo: '/partners/camic.png',
    link: 'https://www.camic.cz/',
  },
];
